import request from '$services/request';
import { apiv2 } from '$services/url';

export const fetchPermissionList = () => {
  return request<string[]>({
    method: 'GET',
    url: apiv2.permissionList
  });
};
